import { useKeycloak } from '@josempgon/vue-keycloak'
import type { Ref } from 'vue';
import type { KeycloakTokenParsed } from 'keycloak-js';
export function useUser(): {
  isAuthenticated: Ref<boolean>;
  isPending: Ref<boolean>;
  hasFailed: Ref<boolean>;
  token: Ref<string>;
  decodedToken: Ref<KeycloakTokenParsed>;
  username: Ref<string>;
  userId: Ref<string>;
  roles: Ref<string[]>;
  resourceRoles: Ref<Record<string, string[]>>;
  hasRoles: (roles: string[]) => boolean;
  hasResourceRoles: (roles: string[], resource: string) => boolean;
  logout: () => Promise<void>;
} {
  const {
    isAuthenticated,
    isPending,
    hasFailed,
    token,
    decodedToken,
    username,
    userId,
    roles,
    resourceRoles,
    hasRoles,
    hasResourceRoles,
    keycloak
  } = useKeycloak()

  async function logout() {
    if (keycloak.value) {
      await keycloak.value.logout();
    }
  }

  return {
    isAuthenticated,
    isPending,
    hasFailed,
    token,
    decodedToken,
    username,
    userId,
    roles,
    resourceRoles,
    hasRoles,
    hasResourceRoles,
    logout
  }
}
